import {
  type BlogpostReference,
  ContentRepresentation,
  type Excerpt,
  type PageReference
} from '@databases/types/confluence';

import { parseConfluenceHTML } from '../lib/dom.ts';
import { serializeMacro } from '../macro.ts';

import { convertContentBody } from './content.ts';

export function parseExcerptMacroText(macroExportView: string): string | null {
  const html = parseConfluenceHTML(macroExportView);
  const panelContent = html.find('div.panelContent');
  return panelContent
    .clone()
    .html(panelContent.html()?.replace(/<p *\/?>/gi, '\n') ?? '')
    .text()
    .trim();
}

export function parseExcerptMacroHtml(
  macroExportView: string
): string | null | undefined {
  const html = parseConfluenceHTML(macroExportView);
  return (
    html
      .find('div.panelContent')
      .html()
      ?.replace(/\r\n|\n|\r/g, '') ?? ''
  ); // remove unnecessary new lines at the first and last line
}

export async function getExcerptMacroContent(
  pageRef: PageReference | BlogpostReference
): Promise<Excerpt> {
  const converted = await convertContentBody(
    {
      value: serializeMacro('excerpt-include', {
        '': pageRef
      }),
      representation: ContentRepresentation.STORAGE
    },
    { to: ContentRepresentation.EXPORT_VIEW }
  );

  return {
    html: parseExcerptMacroHtml(converted.value),
    text: parseExcerptMacroText(converted.value)
  };
}
